import React from 'react';
import { education } from '../data/profile';

const Education = () => {
  return (
    <section id="education" className="section">
      <div className="container">
        <header className="section-head">
          <p className="eyebrow">Education</p>
          <h2>Academic background.</h2>
        </header>
        <div className="edu-list">
          {education.map((item) => (
            <article className="edu-item" key={item.school}>
              <div className="edu-copy">
                <h3>{item.credential}</h3>
                <p>{item.school}</p>
                <p className="edu-meta">
                  {item.period} · {item.location}
                  {item.detail ? ` · ${item.detail}` : ''}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
